import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SpinnerModalService {

    private spinnerModalSubject = new Subject<boolean>();

    public onSpinnerRequest$(): Observable<boolean> {
        return this.spinnerModalSubject.asObservable();
    }

    public show() {
        this.spinnerModalSubject.next(true);
    }

    public hide() {
        this.spinnerModalSubject.next(false);
    }
}
